'use client';

import NextTopLoader from 'nextjs-toploader';
import { useEffect, useState } from 'react';

const THEME_COLORS = {
  default: { light: '#059669', dark: '#10b981' }, // emerald
  blue: { light: '#2563eb', dark: '#3b82f6' },
  green: { light: '#65a30d', dark: '#65a30d' }, // lime
  amber: { light: '#d97706', dark: '#f59e0b' },
  mono: { light: '#525252', dark: '#737373' } // neutral
};

export default function DynamicTopLoader() {
  const [color, setColor] = useState('#059669');

  useEffect(() => {
    const updateColor = () => {
      const isDark = document.documentElement.classList.contains('dark');
      const themeClass = Array.from(document.body.classList).find(
        (cls) => cls.startsWith('theme-') && !cls.includes('scaled')
      );

      let themeName = 'default';
      if (themeClass) {
        themeName = themeClass.replace('theme-', '');
      }

      const themeColor =
        THEME_COLORS[themeName as keyof typeof THEME_COLORS] ||
        THEME_COLORS.default;
      setColor(isDark ? themeColor.dark : themeColor.light);
    };

    // Initial color update
    updateColor();

    // Watch for theme changes
    const observer = new MutationObserver(updateColor);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);

  return <NextTopLoader color={color} showSpinner={false} />;
}
